module.exports = __webpack_public_path__ + "img/Cuba.659a87ac.svg";